<template>
  <div class="nheader">
    <div class="headline">
      <div class="logos">
        <h1 @click="gohome()">新型电力系统博士生创新论坛</h1>

      </div>
      <div v-if="$store.state.userInfo.loginName">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            个人中心<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="baoming">报名参会</el-dropdown-item>
            <el-dropdown-item command="mine">我的参会信息</el-dropdown-item>
            <el-dropdown-item command="editpwd">个人信息修改</el-dropdown-item>
            <el-dropdown-item command="out">安全退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="sbanner">


    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { loginout } from "../../../request/api/user";
export default {
  name: "",
  data() {
    return {};
  },
  created() {
    console.log(this.$store.state.userInfo);
  },
  mounted() {},

  methods: {
    gohome() {
      this.$router.push("/");
    },
    handleCommand(v) {
      if (v == "out") {
        this.logout();
      } else {
        this.$router.push("/" + v);
      }
    },
    logout() {
      loginout({})
        .then((res) => {
          //安全退出
          this.$store.state.showLeftMenu = false;
          this.$store.state.showbg = true;
          localStorage.removeItem("islogin");
          localStorage.removeItem("userInfo");
          this.$store.commit("setUserInfo", "");
          this.$router.push({ path: "/login" });
          this.$message.success("安全退出");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.headline {
  height: 100px;
  padding: 0px 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0060aa;
background: url("../../../assets/image/hbgok.jpg") center no-repeat;
  background-size: cover;
  .logos {
      width: 70%;
      display: flex;
      align-items: center;
      h1{
        font-size:1.5rem;
      }
      
    }
}
.headxian {
  width: 100%;
  height: 22px;
  background: #0060aa;
}
.header {
  height: 130px;
  padding: 20px;
 
  background-size: cover;
  img {
    width: 20%;
  }
}
 .sbanner {
   .bimg {
     display: flex;
     justify-content: center;
     align-items: center;
     img{
      width: 100%;
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/mobile/header/header.vue